export default "__VITE_ASSET__C1QQXw9w__"